import React from 'react'
import List from '../../pages/Menus/List'
import Update from '../../pages/Menus/Update'
import Create from '../../pages/Menus/Create'
import View from '../../pages/Menus/View'
import PrivateRoute from '../PrivateRoute'
import { CustomSwitch } from '../../components/CustomSwitch'

export const MenusRouter = (): JSX.Element => (
  <CustomSwitch>
    <PrivateRoute path="/menus" exact component={List} />
    <PrivateRoute path="/menus/update/:id" component={Update} exact />
    <PrivateRoute path="/menus/create" component={Create} exact />
    <PrivateRoute path="/menus/view/:id" component={View} exact />
  </CustomSwitch>
)
